import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.displaysteuerung-entity-types';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungDisplaysteuerungEntityTypesEffects {

    DisplaysteuerungEntityTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DISPLAYSTEUERUNG_ENTITY_TYPES),
        mergeMap((x: ac.GetDisplaysteuerungEntityTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDisplaysteuerungEntityTypes().pipe(
                map((result: any) => {
                    return new ac.GetDisplaysteuerungEntityTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDisplaysteuerungEntityTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungTemplatesService);
        }
        return this.service;
    }
}
